module.exports = __webpack_public_path__ + "static/media/order_tobacco_inactive.486e45bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order_tobacco_inactive.png
// module id = 1666
// module chunks = 0